/*
* Vietnamese texts
*/
export default {
  // v3
  'processing': 'Processing',
  'delivered': 'Delivered',
  'feedback': 'Feedback',
  'resolved': 'Resolved',
  'golive': 'Go live',

  // Upgrade plan Text Translate
  'PLAN_GLASSON_HEADER': 'GlassOn',
  'PLAN_GLASSON_TITLE_LINE_1': 'Tham gia giải pháp bán hàng mới với dịch vụ thử kính ảo',
  'PLAN_GLASSON_TITLE_LINE_2_P1': 'Dùng thử gói PRO ',
  'PLAN_GLASSON_TITLE_LINE_2_P2': 'miễn phí trong 30 ngày',
  'PLAN_FREE_TITLE': 'FREE',
  'PLAN_PRO_TITLE': 'PRO',
  'PLAN_PRO_FROM': 'Từ',
  'PLAN_PERMONTH_TEXT': 'mỗi tháng',
  'PLAN_PRO_CHECK_OUT_DESCRIPTION': 'Dùng thử tháng đầu miễn phí (tính phí từ tháng thứ 2)',
  'PLAN_FREE_JOIN_NOW_BTN': 'Tham gia',
  'PLAN_PRO_UPGRADE_NOW_BTN': 'Nâng cấp',
  'PLAN_FREE_DESCRIPTION': 'Trải nghiệm dịch vụ GlassOn',
  'PLAN_PRO_DESCRIPTION': 'Cửa hàng, Thương hiệu và Nhà sản xuất',
  'PLAN_SUBCRIPTION_LINE_1_FREE': 'Đăng ký miễn phí 5 sản phẩm',
  'PLAN_SUBCRIPTION_LINE_1_VIRTUAL_TEXT': ' Tính phí trên số lượng sản phẩm đăng ký mua với 100 đơn vị sản phẩm (tham khảo Chi tiết giá)',
  'PLAN_SUBCRIPTION_LINE_1_PRO': 'Đăng ký lên tới 5,000 sản phẩm.Tính phí trên số lượng sản phẩm đăng ký mua với 100 đơn vị sản phẩm',
  'PLAN_SUBCRIPTION_LINE_1_PRO_REFER_TO': 'tham khảo ',
  'PLAN_SUBCRIPTION_LINE_1_PRO_PRICE_DETAIL': 'Chi tiết giá',
  'PLAN_SUBCRIPTION_LINE_2': 'Thử sản phẩm do bạn tạo ra trên ứng dụng GlassOn mobile',
  'PLAN_SUBCRIPTION_LINE_3_P1': 'Tạo liên kết web nhúng cho thử kính ảo',
  'PLAN_SUBCRIPTION_LINE_3_P2': '(Mở tới ứng dụng GlassOn mobile)',
  'PLAN_SUBCRIPTION_LINE_4_P1': 'Tạo mã QR cho thử kính ảo',
  'PLAN_SUBCRIPTION_LINE_4_P2': '(Mở tới ứng dụng GlassOn mobile)',
  //'PLAN_SUBCRIPTION_LINE_5': 'Support 2D Glasses Data',
  'PLAN_SUBCRIPTION_LINE_6': 'Quảng bá sản phẩm của bạn trên "Cửa hàng" của ứng dụng GlassOn mobile',
  'PLAN_FREE_FOOTER_TITLE': 'Nâng cấp bất kỳ lúc nào',
  'PLAN_PRO_FOOTER_TITLE': 'Tăng doanh thu của bạn',
  'PLAN_FREE_TEXT': 'Free',
  'SELECTED_PLAN': 'Selected Plan',
  'SUPPORT_TEXT': 'Cung cấp dịch vụ tạo dữ liệu kính 2D sử dụng trong GlassOn, dịch vụ này được tính phí riêng ',
  'CONTACT_US_TEXT_1': '(',
  'CONTACT_US_TEXT_2': 'liên hệ với chúng tôi',
  'CONTACT_US_TEXT_3': ' để biết thêm chi tiết dịch vụ)',
  'PLAN_DOWNGRADE_BTN': 'Downgrade',
  'BOOST_YOUR_BUSINESS': 'Boost your business',

    // Price Detail Text Translate
  'PRICE_DETAIL_TITLE': 'Bảng giá',
  'PRICE_DETAIL_PRO_PLAN_TITLE': 'GÓI PRO: giá mỗi 100 đơn vị sản phẩm',
  'PRICE_DETAIL_PRO_PLAN_CURRENCY': 'Đơn vị',
  'PRICE_DETAIL_PRO_PLAN_DESCRIPTION': '* Chỉ đăng kí với 100 đơn vị sản phẩm',
  'PRICE_DETAIL_PRO_PLAN_COL_1': 'Số lượng sản phẩm đăng kí',
  'PRICE_DETAIL_PRO_PLAN_COL_2': 'Đơn giá hàng tháng cho mỗi 100 đơn vị sản phẩm',
  'PRICE_DETAIL_PRO_PLAN_COL_3': '6 ~ 300',
  'PRICE_DETAIL_PRO_PLAN_COL_4': '301 trở lên',
  'PRICE_DETAIL_PRO_PLAN_COL_5': 'Tổng cộng',
  'PRICE_DETAIL_PRO_PLAN_EXAMPLE_TEXT': 'Ví dụ: cách tính giá hàng tháng dựa trên số lượng sản phẩm đã đăng ký',

  'PRICE_DETAIL_SUBCRIPTION_TEXT': 'Điều khoản đăng kí thuê bao',
  'PRICE_DETAIL_SUBCRIPTION_LINE_1': 'Lần đầu nâng cấp từ gói Free sang gói PRO, bạn có 30 ngày sử dụng thử miễn phí',
  'PRICE_DETAIL_SUBCRIPTION_LINE_2': 'Thời điểm thanh toán sau mỗi 30 ngày từ thời điểm thanh toán hoặc sau khi hết thời gian dùng thử',
  'PRICE_DETAIL_SUBCRIPTION_LINE_3': 'Bạn có thể chuyển từ gói PRO sang FREE bất kỳ lúc nào, lưu ý những điểm quang trọng dưới đây',
  'PRICE_DETAIL_SUBCRIPTION_LINE_4': 'Lưu ý:',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1': 'Bạn được yêu cầu ',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1_IMP': 'thanh toán ngay tại thời điểm thay đỗi gói sử dụng với số tiền được tính theo dung lượng sử dụng tới thời điểm đó.',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_2': 'Tất cả sản phẩm đều chuyển sang trạng thái "đợi xoá" trong vòng 5 ngày trước khi bị xoá hoàn toàn khỏi hệ thống',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_3': 'Trong trường hợp bạn chuyển trở lại từ gói Free sang PRO, tuỳ theo số lượng sản phẩm đăng ký của gói mới, những sản phẩm mới nhất đang ở trạng thái "đợi xoá" sẽ chuyểng sang trạng thái "hoạt động"',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_TEXT': 'Ví dụ: bạn đăng ký theo tình huống giả định như sau.',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_1': 'Diễn giải',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_2': 'Thời điểm',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_3': 'Số tiền thanh toán',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_4': 'Ghi chú',

  'SUBCRIPTION_EX': 'Ví dụ: bạn đăng ký theo tình huống giả định như sau',
  'SUBCRIPTION_EX_LINE_1': 'Đăng ký lần đầu gói PRO 300 sản phẩm vào ngày 1 tháng 5, sử dụng hết 300 sản phẩm',
  'SUBCRIPTION_EX_LINE_2': 'Thay đổi gói từ Pro sang Free vào ngày 20 tháng 3',
  'SUBCRIPTION_EX_LINE_3': 'Sau đó đăng ký lại gói PRO 100 sản phẩm vào ngày 24 tháng 3',

  'EXPLAIN_LINE_1': 'Chuyển Free sang PRO-100',
  'EXPLAIN_LINE_2': 'Thanh toán lần 1 gói PRO-300',
  'EXPLAIN_LINE_3': 'Thanh toán lần 2 gói PRO-300',
  'EXPLAIN_LINE_4': 'Chuyển PRO sang Free',
  'EXPLAIN_LINE_5': 'Chuyển Free sang PRO-100',
  'EXPLAIN_LINE_6': 'Thanh toán lần 1 gói PRO-100',
  'EXPLAIN_LINE_7': 'Thanh toán lần 2 gói PRO-100',
  'EXPLAIN_LINE_8': 'Thanh toán lần 3 gói PRO-100',
  'NOTE_LINE_1': 'Chương trình dùng thử miễn phí',
  'NOTE_LINE_2': 'Phí cho 1 tháng sử dụng cho gói PRO-300',
  'NOTE_LINE_3': 'Phí sử dụng từ ',
  'NOTE_LINE_4': 'Phí cho 1 tháng sử dụng cho gói PRO-100',
  'SUB_NOTE_LINE_1': '*300 sản phẩn chuyển sang trạng tháu "đợi xoá"',
  'SUB_NOTE_LINE_2': '*100 sản phẩm mới nhất chuyển sang trại thái "hoạt động", 200 sản phẩm còn lại chuyển sang trạng thái "đợi xoá"',
  'SUB_NOTE_LINE_3': '*200 sản phẩm "đợi xoá" bị xoá hoàn toàn',
  'TO': 'tới',
}



// WEBPACK FOOTER //
// ./routes/app/intl/vi.js